<template>
  <VUEModalCaricamentoDati
    v-if="CaricamentoDatiCatena"
    :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"
  />

  <!-- <VUEModal v-if="PopupModificaAllineamento && !Mobile" :Titolo="'Seleziona data allineamento'" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaAllineamento()">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="float:left; width: 30%; margin: 0px">Scegli una data</p>
        <input class="form-control" style="float:left;width:40%" type="datetime-local" step="1" v-model="ObjAllineamento.NuovaDataAllineamento">
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaAllineamento()" data-dismiss="modal">Annulla</button>
      <button v-if="ObjAllineamento.NuovaDataAllineamento != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaAllineamento()" data-dismiss="modal">Conferma</button>
    </template>
  </VUEModal> -->

  <VUEPopupDatiStorici
    v-if="PopupStorici"
    :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_STORICO',this.LinguaUtente) + ']'"
    :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'"
    :VettoreModuli="VettoreModuli"
    :ObjCatena="Catena"
    @OnClickChiudiPopup="OnClickChiudiPopup"
  />

  <VUEPopupStazioneMeteo
    v-if="PopupStazioneMeteo" 
    :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_METEO',this.LinguaUtente) + ']'" 
    :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'" 
    :VettoreModuli="VettoreModuli"
    :ObjCatena="Catena"
    @OnClickChiudiPopup="OnClickChiudiPopupStazioneMeteo"
  />

  <VUEPopupTensioneAssorbimento
    v-if="PopupTensioneAssorbimento" 
    :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_POPUP_SENS_GRAF',this.LinguaUtente) + ']'" 
    :AltezzaPopup="(AltezzaPagina * 0.6) + 'px'" 
    :VettoreModuli="VettoreModuli"
    :ObjCatena="Catena"
    @OnClickChiudiPopup="OnClickChiudiPopupTensioneAssorb"
  />

  <!-- <button type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 10%;min-width:150px" @click="OnClickProva">Prova</button> -->

  <VUEModal
    v-if="PopupSelezioneAllineamento"
    :Titolo="GetTraduzioneLabel('Generic', 'TKN_SELEZ_DATA_ALL', LinguaUtente)"
    Altezza="140px"
    Larghezza="500px"
    :PathLogo="require('@/assets/images/LogoDMS.png')"
    :Programma="'DMSEW'"
    @onClickChiudiModal="AnnullaAllineamento()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row; gap: 5px">
          <label style="width: 100px; margin: 0px; white-space: nowrap; margin: auto 0;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</label>
          <input class="form-control" style="width:30%" type="date" step="1" v-model="ObjAllineamento.DataAllineamento" @change="this.OnChangeDataAllineamento()">     
          <select v-if="ObjAllineamento.ListaOre.length > 0" class="form-control" v-model="ObjAllineamento.OrarioAllineamento">
            <option v-for="Ora in ObjAllineamento.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
          <button v-if="ObjAllineamento.DataAllineamento != null" type="button" class="btn btn-info" style="font-weight:bold;width:32%" @click="TrovaCampioniAllineamento()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
        </div>
        <div v-if="RicercaInCorso" style="margin-top: 10px;" :style="{'color' : Arancione}">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_RICERCA_IN_CORSO',this.LinguaUtente) }}...</p>
        </div>
        <div v-if="!ObjAllineamento.Trovato && !RicercaInCorso" style="margin-top: 10px; color: red">
          <p style="width: 100%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_ALL_NON_TROVATO',this.LinguaUtente) }}</p>
        </div>         
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjAllineamento.DataAllineamento != null && ObjAllineamento.OrarioAllineamento != null && ObjAllineamento.Trovato && ObjAllineamento.ListaOre.length > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupMedia" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_SEL_DATI_MEDIA', LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupMedia()">
    <template v-slot:Body>
      <div class="ZMColumn" style="font-size:14px; align-content: center; justify-content: center; align-items: center; margin-top: 10px;">
        <div class="ZMRow" style="width: 300px; justify-content: space-between;">
          <p style="width: 30px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DAL',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:140px; margin-right: 10px" type="date" step="1" v-model="ObjMedia.Data">
          <select class="form-control" style="width:100px;" v-model="ObjMedia.Ora">
            <option v-for="Ora in ListaOreStandard" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>
        </div>
        <div class="ZMRow" style="width: 300px; margin-top: 10px; justify-content: space-between">
          <p style="width: 100px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_N_ORE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:140px; text-align: right" type="number" step="1" v-model="ObjMedia.Intervallo">
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupMedia()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjMedia.Data != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupMedia()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="ObjFiltroAzimuth.Popup && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_MOD_FILTRO_AZIMUTH', LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaFiltroAzimuth()">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_VAL_FILTRO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:40%" type="number" step="1" v-model="ObjFiltroAzimuth.Filtro">
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjFiltroAzimuth.Filtro != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  
  <VUEModal v-if="ObjModificaAssi.PopupAperto && !Mobile" :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_SEL_DIM_ASSI', LinguaUtente)" Altezza="170px" :Larghezza="(ObjModificaAssi.TipoGrafico != TipiGrafici.Polare ? '500px' : '380px')" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaAssi()">
      <template v-slot:Body>      
        <div style="display: flex; flex-flow: row nowrap;" :style="ObjModificaAssi.TipoGrafico != TipiGrafici.Polare ? {'justify-content' : 'space-between'} : {'justify-content' : 'center'}" >
          <div style="display: flex; flex-flow: column wrap;" :style="ObjModificaAssi.TipoGrafico != TipiGrafici.Polare ? {'width' : '45%'} : {'width' : '65%'}">
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px">
              <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente) }}</h4>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Min">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.X.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Max">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.X.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Udm">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.X.LabelUdm }}</p>
            </div>
          </div>
          <div v-if="ObjModificaAssi.TipoGrafico != TipiGrafici.Polare" style="display: flex; flex-flow: column wrap; width: 45%">
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px">
              <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente) }}</h4>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Min">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.Y.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Max">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.Y.LabelUdm }}</p>
            </div>
            <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
              <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
              <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Udm">
              <p style="width: 15%; margin: 0px">&nbsp;{{ ObjModificaAssi.Y.LabelUdm }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:Footer>
        <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </template>
    </VUEModal>

  <VUEModal v-if="PopupGraficiAbbinati && !Mobile"
            :Titolo="GetTraduzioneLabel('VUEAppContentGraficiVerticali', 'TKN_APP_CON_GRAF_V_MOD_GRAF_ABB', LinguaUtente)"
            Altezza="350px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaModificaAbbinati()">
    <template v-slot:Body>
      
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 22%; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:32%" type="date" step="1" v-model="ObjAbbinati.NuovaDataAbbinato" @change="OnChangeNuovaDataAbbinato()"> 
          <div v-if="ObjAbbinati.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          
          <select v-if="ObjAbbinati.ListaOre.length > 0" class="form-control" style="float:left; width:18%;" v-model="ObjAbbinati.NuovoOrarioAbbinato">
            <option v-for="Ora in ObjAbbinati.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
          </select>

          <div v-if="ObjAbbinati.ListaOre.length > 0" style="float:left; width:2%;">&nbsp;</div>
          <button type="button" class="btn btn-info" style="font-weight:bold;width:24%;padding: 2px;font-size: 12px;" @click="TrovaCampioniPerData()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
        </div>
        
        <div v-if="ObjAbbinati.ListaOre.length > 0" style="width: 100%; margin-top: 10px; display: flex; flex-flow: row wrap; justify-content: end; align-items: right;">
          <button class="btn btn-success" style="font-weight:bold;width:24%;color: green;height: 34px;font-size: 12px;" :title="this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente)" @click="AggiungiDataAbbinato()">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
        </div>

      </div>

      <div v-if="ObjAbbinati.LsGraficiAbbinatiTmp.length > 0" style="width: 100%; margin-top: 10px; overflow-x: auto">
        <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px; max-height: 200px; overflow-y: auto" class="table table-bordered sortable">
          <thead style="background-color: #f2f2f2; font-weight: bold;">
            <tr>
              <th width="30%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
              <th width="25%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
              <th width="20%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>
              <th width="5%"  style="padding: 2px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="Grafico in ObjAbbinati.LsGraficiAbbinatiTmp" :key="Grafico">                        
              <td>
                {{Grafico.PrettyData}}
              </td>
              <td>
                {{Grafico.Ora}}
              </td>  
              <td>
                <label @click="CambiaColoreGrafico(Grafico)" style="width: 80%; margin-left: 10%; margin-top: 5px;" :style="{'background-color' : Grafico.Colore}">&nbsp;</label>
              </td>  
              <td>                
                <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer" @click="RimuoviElemento(Grafico)"></i>
              </td>                                      
            </tr>
          </tbody>
        </table>
      </div>
      <div style="display: flex; align-items: center; justify-content: center; height: 100px" v-else>
        <label>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_GRAFICO',this.LinguaUtente) }}</label>  
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaModificaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" v-if="ObjAbbinati.ListaOre.length <= 0" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEPopupWarning v-if="!Mobile"
                   style="z-index: 9999;"
                   :Popup="PopupWarning"
                   :Richiesta="TestoWarning"
                   :PathLogo="require('@/assets/images/LogoDMS.png')"
                   :Programma="'DMSEW'"
                   @onClickChiudiPopup="PopupWarning = false"/>

  <VUEColorPicker :Popup="PopupColorPicker"
                  Programma="DMSEW"
                  :Colore="ObjColore"
                  @OnClickConfermaPopup="ConfermaColore()"
                  @OnClickChiudiPopup="AnnullaColore()" />

  <VUEColorPicker :Popup="ColorPickerAbbinati"
                  Programma="DMSEW"
                  :Colore="ObjColoreAbbinati"
                  @OnClickConfermaPopup="ConfermaColoreAbbinati()"
                  @OnClickChiudiPopup="AnnullaColoreAbbinati()" />

  <div style="position: absolute; top: -40px; left : 25%; width: 50%; display: flex; flex-flow: column wrap; justify-content: center">
    <label style="font-weight: bold; color: white;font-size: 25px; display: block; text-align: center">{{ Catena.Descrizione }}</label>
  </div>
  <div ref="Container" :style="{'min-width' : Mobile ? undefined : '1250px'}" style="width: calc(100% - 65px); margin-left: 65px">
    <div v-show="!(PopupGraficiAbbinati && Mobile) &&
                 !(PopupSelezioneAllineamento && Mobile) &&
                 !(ObjModificaAssi.PopupAperto && Mobile) &&
                 !ObjIngrandimento.Ingrandito && 
                 !(ObjFiltroAzimuth.Popup && Mobile)" style="width: 100%">
      <div style="width:100%">
        <!-- <div class="col-md-12" :style="{'background-color': Marrone}" style="display: flex; justify-content: center; width:100%; border-bottom: 1px solid white">
          <label style="font-weight: bold; color: white">{{ Catena.Descrizione }}</label>
        </div> -->
        <div style="width: 100%; margin-bottom: 10px" :style="{'display' : Mobile ? undefined : 'flex'}">
          <div v-if="!Mobile" style="border-right:1px solid white;width: 17%">
            <div style="width:100%" :style="{'background-color': Marrone}">&nbsp;</div>
            <div>
              <!-- <img src="../../assets/images/LogoDMS.png"/> -->
            </div>
          </div>
          <div style="border-right:1px solid white; min-width: 266px" :style="GetDimensioniVociMenu('20%')">
            <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold" :style="{'background-color': Marrone}">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_INFO_GEN',this.LinguaUtente) }}</div>
            <div class="col-md-12" style="padding: 0px; display:flex; flex-flow: row wrap">
              <div class="col-md-6" style="display: flex; flex-flow: column wrap; margin-top: 10px; max-width: 50%">
                <div v-for="Info in Catena.LsInfoCatenaLeft" :key="Info">
                  <label style="font-weight: bold; width: 100%">{{Info.Descrizione}}</label>
                  <label style="width: 100%; word-wrap: anywhere;">{{Info.Valore}}</label>
                </div>
              </div>
              <div class="col-md-6" style="display: flex; flex-flow: column wrap; margin-top: 10px; max-width: 50%">
                <div v-for="Info in Catena.LsInfoCatenaRight" :key="Info">
                  <label style="font-weight: bold; width: 100%">{{Info.Descrizione}}</label>
                  <label style="width: 100%">{{Info.Valore}}</label>
                </div>
              </div>
              <!-- <div v-for="Info in Catena.LsInfoCatena" :key="Info">
                <label style="font-weight: bold; width: 100%">{{Info.Descrizione}}</label>
                <label style="width: 100%">{{Info.Valore}}</label>
              </div> -->
            </div>
          </div>
         
          <div style="border-right:1px solid white;" :style="GetDimensioniVociMenu('25%')">
            <div style="display:flex; flex-flow: column nowrap">
              <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold;" :style="{'background-color': Marrone}">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RIALL_DATA',this.LinguaUtente) }}</div>
              <div class="col-md-12" style="display: flex; flex-flow: column wrap; justify-content: center;" :style="{'margin-bottom' : Mobile ? '10px' : '0px'}">
                <div style="display:flex; justify-content: center; width: 100%; margin-top: 5px">
                  <label v-if="ObjAllineamento.DataAllineamento != null">{{ObjAllineamento.PrettyDataAllineamento}}</label>
                  <label v-else>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_DATA',this.LinguaUtente) }}</label>
                </div>
                <div style="width: 100%; display: flex; justify-content: space-between; margin-top: 10px">
                  <button type="button" class="btn btn-info" style="font-weight:bold;width:49%" @click="PopupSelezioneAllineamento = true">{{ this.GetTraduzioneLabel('Generic','TKN_MODIFICA',this.LinguaUtente) }}</button>
                  <button type="button" class="btn btn-info" style="font-weight:bold;width:49%" @click="RimuoviAllineamento()">{{ this.GetTraduzioneLabel('Generic','TKN_RIMUOVI',this.LinguaUtente) }}</button>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; margin-top: 5px" v-if="ObjAllineamento.DataAllineamento != null">                
                  <label style="margin: 0px; margin-right: 5px;">{{ this.GetTraduzioneLabel('Generic','TKN_ALLINEA_TEMPERATURA',this.LinguaUtente) }}</label>
                  <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjAllineamento.AllineaTemperatura">
                </div>
              </div>
            </div>
            <div style="margin-top: 20px; display:flex; flex-flow: column nowrap">
              <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold;" :style="{'background-color': Marrone}">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_DATA_ULT_CAMP',this.LinguaUtente) }}</div>
              <div class="col-md-12" style="display: flex; justify-content: center; margin-top: 5px">              
                <label>{{PrettyUltimaData}}</label>
              </div>
            </div>
          </div>

          <div style="border-right:1px solid white;" :style="GetDimensioniVociMenu('30%')">
            <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold" :style="{'background-color': Marrone}">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_GRAF_ABB',this.LinguaUtente) }}</div>
            <div v-if="ObjAbbinati.LsGraficiAbbinati.length != 0" class="col-md-12">
              <div style="width: 100%; overflow-x: auto">
                <table class="table table-bordered sortable" cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px">
                  <thead style="background-color: #f2f2f2; font-weight: bold;">
                    <tr>
                      <th width="24%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_VISIBILE',this.LinguaUtente) }}</th>
                      <th width="31%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
                      <th width="21%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
                      <th width="19%" style="padding: 2px;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>
                      <th width="5%"  style="padding: 2px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Grafico in ObjAbbinati.LsGraficiAbbinati" :key="Grafico">
                      <td @click="CambiaVisibile(Grafico)" style="padding: 10px; user-select: none">
                        <div style="display: flex; justify-content: center; ">&nbsp; {{ Grafico.Visibile ? 'X' : '' }} &nbsp;</div>
                      </td>                        
                      <td style="padding: 10px;">
                        {{Grafico.PrettyData}}
                      </td>
                      <td style="padding: 10px;">
                        {{Grafico.Ora}}
                      </td>  
                      <td style="padding: 10px;">
                        <label @click="CambiaColoreGrafico(Grafico)" style="width: 80%; margin-left: 10%; margin-top: 5px;" :style="{'background-color' : Grafico.Colore}">&nbsp;</label>
                      </td>      
                      <td style="padding: 10px;">
                        <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer" @click="RimuoviElementoDaTabella(Grafico)"></i>
                      </td>                            
                    </tr>
                  </tbody>
                </table>
              </div>            
            </div>
            <label style="display:flex; justify-content: center; width: 100%; margin-top: 5px" v-if="ObjAbbinati.LsGraficiAbbinati.length == 0">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_GRAF_ABB',this.LinguaUtente) }}</label>
            <div v-if="ObjAbbinati.LsGraficiAbbinati.length == 0" style="margin-top: 14px;"></div>
            <div class="col-md-12" style="display: flex; justify-content: space-between;">        
              <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="AggiungiNuovoGrafico(1, true)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_24H',this.LinguaUtente)}}</button>
              <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="AggiungiNuovoGrafico(2, true)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_48H',this.LinguaUtente) }}</button>
              <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="AggiungiNuovoGrafico(7, true)">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SETT',this.LinguaUtente) }}</button>
              <button type="button" class="btn btn-info" style="font-weight:bold; width: 24%" @click="ApriPopupGraficiAbbinati()">{{ this.GetTraduzioneLabel('Generic','TKN_MODIFICA',this.LinguaUtente) }}</button>    
            </div>
            <div class="col-md-12" style="display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center; margin-bottom: 15px">
              <div style="margin-top: 13px; width:170px; display: flex">
                <label style="font-weight: bold; margin-bottom: 0px; margin-right: 20px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_REC',this.LinguaUtente) }}</label>          
                <input class="form-control" v-model="MostraUltimo" style="margin:0px; height: 22px; width: 25px;" type="checkbox" @change="ToggleUltimaData()">
              </div>
              <div style="display: flex; justify-content: flex-end" v-if="MostraUltimo">
                <label style="font-weight: bold; margin-bottom: 0px; margin-right: 20px">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</label>
                <div :style="{'background-color' : ObjColore.ColoreScelto, 'width' : '50px'}" @click="CambiaColoreUltimo()">&nbsp;</div>
              </div>
              <div style="width: 100%">
                <div style="text-align: center; display: flex; padding-top: 12px;">
                  <label style="font-weight: bold; margin-bottom: 0px; margin-right: 5px;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RINFR_AUTO',this.LinguaUtente) }}</label>          
                  <input class="form-control" v-model="FlagAbilitaRefreshDati" style="margin:0px; height: 22px; width: 25px;" type="checkbox">
                </div>
              </div>
            <!-- <div style="display: flex; justify-content: center;">
                <button type="button" class="btn btn-info" style="font-weight:bold;" @click="ApriPopupGraficiAbbinati()">Modifica</button>
              </div> -->
            </div>
          </div>
          
          <div :style="GetDimensioniVociMenu('15%')">
            <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold" :style="{'background-color': Marrone}">{{this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_POLARE',this.LinguaUtente) + (ObjAllineamento.DataAllineamento != null ? ' (a)' : '')}}</div>
            <div ref="Polare" style="margin-left: calc((100% - 237px) / 2);" :style="Mobile ? {'width' : '80%', 'margin-left' : '10%', 'height' : '300px'} : {'height' : '237px'}">           
              <VUEComponenteGraficoGenerico v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                :AllineamentoSelezionato="ObjAllineamento.DataAllineamento" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.Polare"
                                                                :LarghezzaGrafico="$refs.Polare.clientHeight" :AltezzaGrafico="$refs.Polare.clientHeight"  :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale" :AddDatiPDF="AddDatiPDF"
                                                                :ObjEsportazione="ObjEsportazione" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico> 
            </div>
          </div>
        </div>
        <div style="width: calc(100% + 50px); margin-left: -50px;" :style="{'display' : Mobile ? undefined : 'flex'}" ref="Container">
          <div style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_N',this.LinguaUtente) + (ObjAllineamento.DataAllineamento != null ? ' (a)' : '')}} </label>
            </div>
            <div ref="SpostNord" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 12" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.SpostNord"
                                                                                    :LarghezzaGrafico="$refs.SpostNord.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
          <div style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_E',this.LinguaUtente) + (ObjAllineamento.DataAllineamento != null ? ' (a)' : '')}}</label>
            </div>
            <div ref="SpostEst" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 11" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true" 
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.SpostEst"
                                                                                    :LarghezzaGrafico="$refs.SpostEst.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
          <div style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_T',this.LinguaUtente) + (ObjAllineamento.DataAllineamento != null ? ' (a)' : '')}}</label>
            </div>
            <div ref="SpostTot" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 10" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.SpostTot"
                                                                                    :LarghezzaGrafico="$refs.SpostTot.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
          <div style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_AZIMUTH',this.LinguaUtente) + (ObjAllineamento.DataAllineamento != null ? ' (a)' : '')}}</label>
            </div>
            <div ref="SpostAzimuth" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 9" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" @ApriPopupFiltroAzimuth="ApriPopupFiltroAzimuth"
                                                                                    :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.SpostAzimuth"
                                                                                    :LarghezzaGrafico="$refs.SpostAzimuth.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
          <div style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(true)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ((ObjAllineamento.DataAllineamento != null && ObjAllineamento.AllineaTemperatura) ? ' (a)' : '')}}</label>
            </div>
            <div ref="Temperatura" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 8" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.Temperatura"
                                                                                    :LarghezzaGrafico="$refs.Temperatura.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi"  :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AllineaTemperatura="ObjAllineamento.AllineaTemperatura" :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
          <div style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{ this.GetTraduzioneLabel('Generic','TKN_PIEZOMETRO',this.LinguaUtente) }}</label>
            </div>
            <div ref="Piezometro" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 7" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.Piezometro"
                                                                                    :LarghezzaGrafico="$refs.Piezometro.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
          <div v-if="false" style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_EV_ACC',this.LinguaUtente) }}</label>
            </div>
            <div style="width:100%;background-color: green;" :style="{'height' : '300px'}">
            </div>
          </div>
          <div v-if="Catena.EstensimetroPresente" style="border-right:1px solid white" :style="GetDimensioniGraficiVerticali(false)">
            <div style="width:100%; display: flex; justify-content: center" :style="{'background-color': Marrone}">
              <label style="font-weight: bold; color: white">{{this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_DEF',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']' + (ObjAllineamento.DataAllineamento != null ? ' (a)' : '')}}</label>
            </div>          
            <div ref="Estensimetri" style="width:100%">
              <VUEComponenteGraficoGenerico style="z-index: 6" v-if="MostraGrafici" @ApriDettaglio="ApriDettaglio" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo * 0.6" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                    :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="TipiGrafici.Deformazione"
                                                                                    :LarghezzaGrafico="$refs.Estensimetri.clientWidth" :AltezzaGrafico="AltezzaGrafici" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                    :AddDatiPDF="AddDatiPDF" :ModificaGraficiAll="ModificaGraficiAll">
              </VUEComponenteGraficoGenerico>
            </div>
          </div>
        </div>
        <div v-if="!Mobile" style="width:100%;">
          <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 10px; width: 14%" @click="AdattaGrafici()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_ADATTA_GRAF',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 10px; width: 14%" @click="EsportaComePDF()">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 10px; width: 14%" @click="CambiaDifferenziale()">{{ObjDifferenziale.ScrittaBottone}}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 10px; width: 14%" @click="ApriPopupMedia()">{{MediaAttiva ? (this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RIMUOVI_MEDIA',this.LinguaUtente)) : (this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MEDIA_ARIT',this.LinguaUtente))}}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 10px; width: 14%" @click="CambiaScaleAll()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CAMBIA_SCALE',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 10px; width: 14%" @click="AdattaGrafici(false)">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MASSIMIZZA',this.LinguaUtente) }}</button>
        </div>
        <div v-else style="margin: 5px">
          <div>
            <button type="button" class="btn btn-info" style="font-weight:bold; width: 49.5%" @click="AdattaGrafici()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_ADATTA_GRAF',this.LinguaUtente) }}</button>
            <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 1%; width: 49.5%" @click="EsportaComePDF()">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
          </div>
          <div style="margin-top: 5px">
            <button type="button" class="btn btn-info" style="font-weight:bold; width: 49.5%" @click="CambiaDifferenziale()">{{ObjDifferenziale.ScrittaBottone}}</button>
            <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 1%; width: 49.5%" @click="ApriPopupMedia()">{{MediaAttiva ? (this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RIMUOVI_MEDIA',this.LinguaUtente)) : (this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MEDIA_ARIT',this.LinguaUtente))}}</button>
          </div>
          <div style="margin-top: 5px">
            <button type="button" class="btn btn-info" style="font-weight:bold; width: 49.5%" @click="CambiaScaleAll()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CAMBIA_SCALE',this.LinguaUtente) }}</button>
            <button type="button" class="btn btn-info" style="font-weight:bold; margin-left: 1%; width: 49.5%" @click="AdattaGrafici(false)">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MASSIMIZZA',this.LinguaUtente) }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="PopupGraficiAbbinati && Mobile" style="width: 84%; margin-left: 8%">
      <div style="display: flex; justify-content: center">
        <h3>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TIT_GRAF_ABBINATI',this.LinguaUtente) }}</h3>
      </div>
      <div v-if="Mobile && PopupWarning" style="width: 100%; font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 10px">
        <label style="color: red">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_DATA_PRESENTE',this.LinguaUtente) }}</label>
      </div>
      <div style="width: 100%; font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <div style="width: 350px; display: flex; flex-flow: row wrap; justify-content: space-between;">
            <p style="width: 100px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
            <input class="form-control" style="width:200px" type="date" step="1" v-model="ObjAbbinati.NuovaDataAbbinato">
          </div>        
          <div v-if="ObjAbbinati.ListaOre.length > 0" style="display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center;" :style="Mobile ? {'width': '140px', 'margin-top' : '10px'} : {'width': '180px'}">
            <select class="form-control" style="float:left; width:70%;" v-model="ObjAbbinati.NuovoOrarioAbbinato">
              <option v-for="Ora in ObjAbbinati.ListaOre" :key="Ora" :value="Ora">{{Ora}}</option>
            </select>
            <i class="fa fa-plus" style="color: green" :title="this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente)" @click="AggiungiDataAbbinato()"></i>
          </div>  
          <button type="button" class="btn btn-info" :style="Mobile ? {'margin-top' : '10px'} : {'width': '32%'}" style="font-weight:bold;" @click="TrovaCampioniPerData()">{{ this.GetTraduzioneLabel('Generic','TKN_CERCA_CAMP',this.LinguaUtente) }}</button>
        </div>    
      </div>
      <div v-if="ObjAbbinati.LsGraficiAbbinatiTmp.length > 0" style="margin-top: 10px; overflow-x: auto" :style="Mobile ? {'width': '100%'} : {'width': '80%', 'margin-left': '10%'}">
        <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px; max-height: 200px; overflow-y: auto" class="table table-bordered sortable">
          <thead>
            <tr>
              <th width="30%">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</th>
              <th width="25%">{{ this.GetTraduzioneLabel('Generic','TKN_ORA',this.LinguaUtente) }}</th>
              <th width="20%">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>
              <th width="5%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="Grafico in ObjAbbinati.LsGraficiAbbinatiTmp" :key="Grafico">                        
              <td style="padding: 10px;">
                {{Grafico.PrettyData}}
              </td>
              <td style="padding: 10px;">
                {{Grafico.Ora}}
              </td>  
              <td style="padding: 10px;">
                <label style="width:100%; margin: 0px;" :style="{'background-color' : Grafico.Colore}">&nbsp;</label>
              </td>  
              <td style="padding: 10px;">                
                <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer" @click="RimuoviElemento(Grafico)"></i>
              </td>                                      
            </tr>
          </tbody>
        </table>
      </div>
      <div style="display: flex; align-items: center; justify-content: center; height: 100px" v-else>
        <label>{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_NO_GRAFICO',this.LinguaUtente) }}</label>  
      </div>
      <div style="margin-top: 30px;">
        <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;" @click="AnnullaModificaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-success" style="float:right;font-weight:bold;" @click="ConfermaAbbinati()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </div>
    </div>
    <div v-show="PopupSelezioneAllineamento && Mobile" style="width: 100%">
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="float:left; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_SCEGLI_DATA',this.LinguaUtente) }}</p>
      </div>
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <input class="form-control" style="float:left;width:60%" type="datetime-local" step="1" v-model="ObjAllineamento.NuovaDataAllineamento">
      </div>
      <div style="margin-top : 20px; display: flex; align-content: center; justify-content: center; align-items: center">
        <button type="button" class="btn btn-danger" style="margin-right:10px;font-weight:bold;" @click="AnnullaModificaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button v-if="ObjAllineamento.NuovaDataAllineamento != ''" type="button" class="btn btn-success" style="font-weight:bold;" @click="ConfermaModificaAllineamento()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </div>
    </div>
    <div v-if="ObjFiltroAzimuth.Popup && Mobile" style="width: 100%">
      <div class="form-row" style="font-size:14px; display: flex; align-content: center; justify-content: center; align-items: center; margin-top: 30px">
        <p style="width: 30%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_VAL_FILTRO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:40%" type="number" step="1" v-model="ObjFiltroAzimuth.Filtro">
      </div>
      <div style="display: flex; flex-flow: row wrap; margin-top: 20px; justify-content: center">
        <button type="button" class="btn btn-danger" style="margin-right:10px;font-weight:bold;" @click="AnnullaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button v-if="ObjFiltroAzimuth.Filtro != null" type="button" class="btn btn-success" style="font-weight:bold;" @click="ConfermaModificaFiltroAzimuth()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>        
      </div>
    </div>
    <div v-if="ObjModificaAssi.PopupAperto && Mobile" style="display: flex; flex-flow: column nowrap;">
      <div style="display: flex; flex-flow: column wrap; width: 90%; margin-left: 5%">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px; margin-top: 10px">
          <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente) }}</h4>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Min">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.X.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Max">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.X.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.X.Udm">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.X.LabelUdm }}</p>
        </div>
      </div>
      <div style="display: flex; flex-flow: column wrap; width: 90%; margin-left: 5%">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 10px; margin-top: 10px">
          <h4 style="margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente) }}</h4>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Min">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.Y.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Max">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.Y.LabelUdm }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:45%; text-align: right;" type="number" step="1" v-model="ObjModificaAssi.Y.Udm">
          <p style="width: 15%; margin: 0px">{{ ObjModificaAssi.Y.LabelUdm }}</p>
        </div>
      </div>
      <div style="display: flex; flex-flow: row wrap; margin-top: 20px; margin-left: 5%; width: 90%">
        <button type="button" class="btn btn-danger" style="margin-right:10px;font-weight:bold;" @click="AnnullaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
        <button type="button" class="btn btn-success" style="font-weight:bold;" @click="ConfermaModificaAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      </div>
    </div>
    <div v-if="ObjIngrandimento.Ingrandito">
      <div style="display: flex; flex-flow: row wrap; margin: 10px">
        <button type="button" class="btn btn-info" style="margin-right:10px;font-weight:bold;" @click="TornaAllaVisualizzazione()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TORNA_VIS',this.LinguaUtente) }}</button>        
      </div>
      <div style="display: flex; flex-flow: row wrap">      
        <div style="display: flex; flex-flow: column wrap; width: 50%">
          <VUEComponenteGraficoGenerico v-if="MostraGrafici" @ApriDettaglio="null" :CatenaInfo="Catena" :StatoAbbinati="StatoAbbinati" :AltezzaPopup="AltezzaSchermo" :OnDashboard="false" :Contatore="0" :MostraGrafici="true"
                                                                                :AllineamentoSelezionato="null" :GraficiChange="GraficiChange" :GraficiAdatta="GraficiAdatta" :Zoom="1" :TipoGrafico="ObjIngrandimento.TipoGrafico"
                                                                                :LarghezzaGrafico="ObjIngrandimento.Larghezza" :AltezzaGrafico="ObjIngrandimento.Altezza" :ObjModificaAssi="ObjModificaAssi" :Differenziale="ObjDifferenziale.Differenziale"
                                                                                :Ingrandito="true" :AllineaTemperatura="ObjAllineamento.AllineaTemperatura">
          </VUEComponenteGraficoGenerico>      
        </div>
        <div style="display: flex; flex-flow: column wrap; width: 50%; overflow-y: auto;" :style="{'max-height' : ObjIngrandimento.Altezza - 30 + 'px'}">
          <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 5px; margin-bottom: 5px; min-width: 400px; overflow-y: auto" class="table table-bordered sortable">
            <thead style="position: sticky; top: 0; left: 0; background-color: white;">
              <tr>
                <th v-for="Campo in ObjIngrandimento.Campi" :key="Campo" :width="Campo.Dimensione">{{ Campo.Campo }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="Dato in ObjIngrandimento.Dati" :key="Dato">        
                <td v-for="Voce in Dato.Voci" :key="Voce" :colspan="Dato.Separatore ? 99 : 1" style="text-align: right; vertical-align: middle"
                  :style="Dato.Separatore ? {'background-color' : Arancione, 'font-weight' : 'bold', 'color' : 'white', 'height' : '30px'} : {}">
                  {{Voce}}
                </td>                                   
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import XLSX from 'xlsx-js-style/dist/xlsx.min.js'
import {
         SystemInformation, TTools, 
         COLORI_PANTONE, COLORE_GRAFICI_VERTICALI, 
         TIPI_GRAFICI, COLORI_DEFAULT_GRAFICI,
         TInfoGraficiStorici, LOCALSTORAGE,
       }
       from '../../SystemInformation.js'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica.js';
import VUEModal from '@/utils/VUEModal.vue';
import VUEPopupWarning from '@/components/Popups/VUEPopupWarning.vue';
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEModalCaricamentoDati from '@/utils/VUEModalCaricamentoDati.vue'
import VUEComponenteGraficoGenerico from '../../components/Slots/VUEComponenteGraficoGenerico.vue';
import VUEPopupDatiStorici from '../../components/Popups/VUEPopupDatiStorici.vue';
import VUEPopupStazioneMeteo from '../../components/Popups/VUEPopupStazioneMeteo.vue';
import VUEPopupTensioneAssorbimento from '../../components/Popups/VUEPopupTensioneAssorbimento.vue';
import { TZDateFunct } from '@/utils/ZDateFunct.js';
import { TZMathFunct } from '@/utils/ZMathFunct.js';
import { TZStringConvFunct } from '@/utils/ZStringConvFunct';
import { saveAs } from 'file-saver';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import MixInsDoubleClickHandler from './MixInsDoubleClickHandler.js';

export default
{
    components: 
    {
      VUEModal,
      VUEComponenteGraficoGenerico,
      VUEPopupWarning,
      VUEColorPicker,
      VUEPopupDatiStorici,
      VUEModalCaricamentoDati,
      VUEPopupTensioneAssorbimento,
      VUEPopupStazioneMeteo,
    },
    props: ["AltezzaPagina", "ObjPresenzaMenu"],
    mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
    data() 
    {
      return  {
                Mobile                      : TZGenericFunct.IsClientMobile(),
                CaricamentoDatiCatena       : false,
                AltezzaSchermo              : 0,
                Marrone                     : COLORI_PANTONE.Marrone,
                Arancione                   : COLORI_PANTONE.Arancione,
                Catena                      : {},
                GraficiChange               : 0,
                GraficiAdatta               : 0,
                VettoreModuli               : [],
                ObjAbbinati                 : {
                                                LsGraficiAbbinati    : [],
                                                LsGraficiAbbinatiTmp : [],
                                                NuovaDataAbbinato    : this.GetDataOdierna(),
                                                NuovoOrarioAbbinato  : null,
                                                DatiTrovati          : true,
                                                ListaOre             : []
                                              },
                MostraUltimo                : true,
                ObjAllineamento             : {
                                                DataAllineamento       : null,
                                                OrarioAllineamento     : null,
                                                ListaOre               : [],
                                                DataOraAllineamento    : null, 
                                                PrettyDataAllineamento : '',
                                                NuovaDataAllineamento  : '',
                                                AllineaTemperatura     : false,
                                                Trovato                : true
                                              },
                PopupSelezioneAllineamento  : false,
                PopupGraficiAbbinati        : false,
                PopupSelezioneNuovaData     : false,
                ChiaveCatena                : -1,
                ChiaveSito                  : -1,
                MostraGrafici               : false,            
                UltimaData                  : null,
                ColoreGrafico               : COLORE_GRAFICI_VERTICALI,
                TipiGrafici                 : TIPI_GRAFICI,
                PopupWarning                : false,
                TestoWarning                : false,
                PopupColorPicker            : false,
                ColorPickerAbbinati         : false,
                ObjColore                   : {Colore: COLORE_GRAFICI_VERTICALI.Grafico, ColoreScelto: COLORE_GRAFICI_VERTICALI.Grafico},
                ObjColoreAbbinati           : {Colore: COLORE_GRAFICI_VERTICALI.Grafico, ColoreScelto: COLORE_GRAFICI_VERTICALI.Grafico},
                ObjDimensioni               : {},
                ObjModificaAssi             : {
                                                PopupAperto : false,
                                                TipoGrafico : -1,
                                                ModificaEffettuata : false,
                                                X : {Min : 0, Max : 0, Udm : 0, LabelUdm : ''},
                                                Y : {Min : 0, Max : 0, Udm : 0, LabelUdm : ''}
                                              },
                ObjIngrandimento            : {
                                                Ingrandito        : false,
                                                TipoGrafico       : -1,
                                                ProprietaGrafiche : null,
                                                Campi             : []
                                              },
                ObjFiltroAzimuth            : {
                                                Popup  : false,
                                                Filtro : 0,
                                                ObjGrafico : null 
                                              },
                ObjDifferenziale            : {
                                                Differenziale  : false,
                                                TitoliBottone  : {Cumulativo: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_DIFF',SystemInformation.UserInformation.Lingua), Differenziale: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_CUM',SystemInformation.UserInformation.Lingua)}, 
                                                ScrittaBottone : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_DIFF',SystemInformation.UserInformation.Lingua)
                                              },
                MaxMinGraph                 : 0,
                AddDatiPDF                  : 0,
                AltezzaGrafici              : 300,
                LarghezzaSchermo            : 0,
                PrettyUltimaData            : '',
                ObjEsportazione             : {},
                MenuTrigger                 : SystemInformation.MenuTrigger,
                PopupStorici                : false,
                PopupTensioneAssorbimento   : false,
                PopupStazioneMeteo          : false,
                ModificaGraficiAll          : 0,
                GraficoSelezionato          : null,
                ObjMedia                    : {Data : '', Ora: '00:00', Intervallo: 24},
                MediaAttiva                 : false,
                PopupMedia                  : false,
                StatoAbbinati               : [],
                RicercaInCorso              : false,
                IntervalIDRefreshDati       : false,
                FlagAbilitaRefreshDati      : false,
                LinguaUtente                : SystemInformation.UserInformation.Lingua
            };        
    },
    methods:
    {
      CambiaVisibile(Grafico)
      {
        Grafico.Visibile = !Grafico.Visibile
        this.StatoAbbinati = []
        for (let  i = 0; i < this.ObjAbbinati.LsGraficiAbbinati.length; i++)
        {
          let SingleGraph = this.ObjAbbinati.LsGraficiAbbinati[i]
          this.StatoAbbinati.push({Data: SingleGraph.DataCompleta, Visibile: SingleGraph.Visibile})
        } 
        this.GraficiChange++
        // VEDERE COME FARE PER RIDISEGNARE
      },

      GetDataOdierna() 
      {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },

      ApriPopupMedia()
      {
        if (!this.MediaAttiva)
        {
          this.ObjMedia.Data = TZDateFunct.FormatDateTime('yyyy-mm-dd', new Date(this.UltimaData.Data))
          this.ObjMedia.Ora  = TZDateFunct.FormatDateTime('hh:nn', new Date(this.UltimaData.Data))
          this.ObjMedia.Intervallo = 24
          this.PopupMedia = true
        }
        else
        {
          this.MediaAttiva = false
          this.CaricaDatiCatena()
        }
      },

      AnnullaPopupMedia()
      {
        this.PopupMedia = false
      },

      ConfermaPopupMedia()
      {
        this.MediaAttiva = true
        this.PopupMedia = false
        this.CaricamentoDatiCatena = true 
        this.CaricaDatiCatena(()=>
        {
          this.CaricamentoDatiCatena = false
        })
      },

      CambiaColoreGrafico(Grafico)
      {
        this.GraficoSelezionato = Grafico
        this.ObjColoreAbbinati.ColoreScelto = Grafico.Colore 
        this.ObjColoreAbbinati.Colore = Grafico.Colore
        this.ColorPickerAbbinati   = true        
      },

      CambiaColoreUltimo()
      {
        this.GraficoSelezionato = null
        this.ObjColore.Colore = this.UltimaData.Colore
        this.PopupColorPicker   = true          
      },

      CambiaScaleAll()
      {
        this.ObjModificaAssi.TipoGrafico = -1
        this.ObjModificaAssi.ModificaEffettuata = false
        this.ModificaGraficiAll++
      },

      EsportaExcel()
      {
        const wb = XLSX.utils.book_new();
        let ArrayContenitore = []
        let DatiGenerali = this.ObjEsportazione.Generale
        let RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + " " + DatiGenerali.DESCRIZIONE, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_REPORT_DEL',this.LinguaUtente) + " " + DatiGenerali.DataCampione, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_PROGETTO',this.LinguaUtente) + ":" + DatiGenerali.PROGETTO, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        let Row = 
          [
            { v: this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_N',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_E',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MOD_SPOST',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_AZIMUT',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_GRADI_NORD',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          ];
        ArrayContenitore.push(Row)

        this.ObjEsportazione.Punti.forEach(function(elemento)
        {
          let RowElemento = 
          [
            { v: (parseFloat(elemento.Profondita)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}},
            { v: (parseFloat(elemento.SpostNord)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (parseFloat(elemento.SpostEst)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (parseFloat(elemento.SpostTotale)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (parseFloat(elemento.Azimuth)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (parseFloat(elemento.Temperatura)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          ];
          ArrayContenitore.push(RowElemento)
        })

        const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
        XLSX.utils.book_append_sheet(wb, ws, "REPORT_" + DatiGenerali.Differenziale ? this.GetTraduzioneLabel('UdmGenerali','TKN_APP_CON_GRAF_V_EXC_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('UdmGenerali','TKN_APP_CON_GRAF_V_EXC_CUM',this.LinguaUtente));

        var wscols = [
                        {wch:40},
                        {wch:40},
                        {wch:40},
                        {wch:40},
                        {wch:40},
                        {wch:40},
                      ];
                      
        ws['!cols'] = wscols;

        XLSX.writeFile(wb, this.ObjEsportazione.Generale.DESCRIZIONE + '_' + this.ObjEsportazione.Generale.DataCampione + ".xlsx");
      },

      AdattaGrafici(Adatta = true)
      {
        let MaxMinGraph = 0

        if(this.UltimaData?.MinTemperatura != null || this.UltimaData?.MinTemperatura != undefined)
          this.UltimaData.MinTemperatura /= 10

        if(this.UltimaData?.MaxTemperatura != null || this.UltimaData?.MaxTemperatura != undefined)
          this.UltimaData.MaxTemperatura /= 10
        
        for (let j = 0; j < this.Catena.DatiCatena.Spostamenti.Date.length; j++)
        {
          let SumSpostEst           = 0
          let SumSpostNord          = 0
          let SumSpostAllineatoNord = 0
          let SumSpostAllineatoEst  = 0
          let Spostamenti           = this.Catena.DatiCatena.Spostamenti.Date[j].Moduli

          for(let k = 0; k < Spostamenti.length; k++)
          {
            let Spostamento  = Spostamenti[k]
            let Allineamento = null

            if(this.Catena.DatiCatena.Allineamento != null && this.Catena.DatiCatena.Allineamento.Moduli != null)
              Allineamento = this.Catena.DatiCatena.Allineamento.Moduli[k]
            
            if(!this.ObjDifferenziale.Differenziale)
            {
              SumSpostEst  = SumSpostEst - Spostamento.SpostamentoEst / 1_000
              SumSpostNord = SumSpostNord - Spostamento.SpostamentoNord / 1_000
            }
            else
            {
              SumSpostEst  = Spostamento.SpostamentoEst / 1_000
              SumSpostNord = Spostamento.SpostamentoNord / 1_000
            }
            
            if(Allineamento != null)
            {
              SumSpostAllineatoNord = SumSpostAllineatoNord - Allineamento.SpostamentoNord / 1_000
              SumSpostAllineatoEst  = SumSpostAllineatoEst - Allineamento.SpostamentoEst / 1_000

              if (Math.abs(SumSpostEst - SumSpostAllineatoEst) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostEst - SumSpostAllineatoEst)

              if (Math.abs(SumSpostNord - SumSpostAllineatoNord) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostNord - SumSpostAllineatoNord)
            }
            else
            {
              if(Math.abs(SumSpostEst) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostEst)

              if(Math.abs(SumSpostNord) > MaxMinGraph)
                MaxMinGraph = Math.abs(SumSpostNord)
            }
          }
        }

        TTools.AdattaScaleGrafici([this.Catena], MaxMinGraph, MaxMinGraph, this.ObjDifferenziale.Differenziale,
                                  this.Catena.DatiCatena.MinProfondita, this.Catena.DatiCatena.MaxProfondita,
                                  this.UltimaData?.MinTemperatura, this.UltimaData?.MaxTemperatura,
                                  this.UltimaData?.MinDeformazione, this.UltimaData?.MaxDeformazione, Adatta)
        
        this.GraficiAdatta++
      },

      TornaAllaVisualizzazione()
      {
        this.ObjIngrandimento.Ingrandito = false
        setTimeout(()=>{this.GraficiChange++}, 50)
      },

      ResizeGraphs()
      {
        this.AltezzaSchermo = window.innerHeight
        this.LarghezzaSchermo = window.innerWidth
        this.AltezzaGrafici = this.AltezzaPagina - 430
        if (this.AltezzaGrafici < 300)
          this.AltezzaGrafici = 300
      },

      EsportaComePDF()
      {
        let DataOdierna = new Date()
        let NomeGrafico = this.Catena.DatiCatena.DESCRIZIONE.replace('-', '') + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + '.pdf'
        this.Catena.DatiPDF = []
        this.AddDatiPDF++
        let Data = this.Catena.DatiCatena.Spostamenti.Date[0].Data
        for (let i = 0; i < this.Catena.DatiCatena.Spostamenti.Date.length; i++)
        {
          if (Data < this.Catena.DatiCatena.Spostamenti.Date[i].Data)
            Data = this.Catena.DatiCatena.Spostamenti.Date[i].Data
        }
        setTimeout(() => 
        {
          SystemInformation.AdvQuerySiti.ExecuteExternalScript('StampaPDFGrafico',  { 
                                                                                      Catena  : this.Catena.DatiCatena.CHIAVE,
                                                                                      Data    : Data,
                                                                                      Grafici : this.Catena.DatiPDF
                                                                                    },
                                                            function(Result)
                                                            {
                                                              saveAs(TZStringConvFunct.Base64AsBlob(Result.PDF), NomeGrafico)
                                                            },
                                                            function(HTTPError,SubHTTPError,Response)
                                                            {
                                                              SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          })
        }, 50);
      },

      CambiaDifferenziale()
      {
        this.ObjDifferenziale.Differenziale = !this.ObjDifferenziale.Differenziale
        if (this.ObjDifferenziale.Differenziale)
          this.ObjDifferenziale.ScrittaBottone = this.ObjDifferenziale.TitoliBottone.Differenziale
        else
          this.ObjDifferenziale.ScrittaBottone = this.ObjDifferenziale.TitoliBottone.Cumulativo
        this.AdattaGrafici()
      },

      ConfermaColoreAbbinati()
      {
        this.ObjColoreAbbinati.ColoreScelto = TZGenericFunct.GetHexColorFromRGB(this.ObjColoreAbbinati.Colore)
        this.ColorPickerAbbinati = false
        this.GraficoSelezionato.Colore = this.ObjColoreAbbinati.ColoreScelto
        let ObjData = this.Catena.DatiCatena.Spostamenti.Date.find((element) => {return element.Data == this.GraficoSelezionato.DataCompleta})
        if (ObjData != undefined)
        {
          ObjData.Colore = this.ObjColoreAbbinati.ColoreScelto
          ObjData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, this.Catena.DatiGrafici.MARKUP_WIDTH)
          ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', this.Catena.DatiGrafici.MARKUP_WIDTH)            
        }
        this.GraficiChange++
      },

      AnnullaColoreAbbinati()
      {
        this.ObjColoreAbbinati.Colore = this.ObjColoreAbbinati.ColoreScelto
        this.ColorPickerAbbinati = false
        this.GraficoSelezionato = null
      },

      ConfermaColore()
      {
        this.ObjColore.ColoreScelto = TZGenericFunct.GetHexColorFromRGB(this.ObjColore.Colore)
        this.PopupColorPicker = false
        this.UltimaData.Colore = this.ObjColore.ColoreScelto
        let ObjUltimaData = this.Catena.DatiCatena.Spostamenti.Date.find((element) => {return element.Ultima})
        if (ObjUltimaData != undefined)
        {
          ObjUltimaData.Colore = this.ObjColore.ColoreScelto
          ObjUltimaData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjUltimaData.Colore, this.Catena.DatiGrafici.MARKUP_WIDTH)
          ObjUltimaData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', this.Catena.DatiGrafici.MARKUP_WIDTH)   
        }
        this.GraficiChange++
      },

      AnnullaColore()
      {
        this.ObjColore.Colore = this.ObjColore.ColoreScelto
        this.PopupColorPicker = false
        this.GraficoSelezionato = null
      },

      ApriDettaglio(TipoGrafico, ObjGraficoCompilato)
      {
        this.ObjIngrandimento.TipoGrafico = TipoGrafico
        this.ObjIngrandimento.ProprietaGrafiche = ObjGraficoCompilato
        this.ObjIngrandimento.CatenaInfo = TZGenericFunct.GetCopyOfObject(this.Catena)
        this.ObjIngrandimento.Altezza   = this.Mobile ? 500 : (this.$refs.Container.clientHeight - 22)
        if(TipoGrafico == this.TipiGrafici.Polare)
          this.ObjIngrandimento.Larghezza   = this.ObjIngrandimento.Altezza
        else this.ObjIngrandimento.Larghezza = (this.$refs.Container.clientWidth / 2)
        this.ObjIngrandimento.Ingrandito = true
        this.GetDatiTableIngrandimento()
      },

      ApriPopupFiltroAzimuth(ObjGrafico)
      {
        this.ObjFiltroAzimuth.ObjGrafico = ObjGrafico
        this.ObjFiltroAzimuth.Filtro = ObjGrafico.FiltroAzimuth
        this.ObjFiltroAzimuth.Popup = true 
      },

      AnnullaModificaFiltroAzimuth()
      {
        this.ObjFiltroAzimuth.Popup = false
        this.ObjFiltroAzimuth.ObjGrafico = null
        this.ObjFiltroAzimuth.Filtro = 0
      },

      ConfermaModificaFiltroAzimuth()
      {
        this.ObjFiltroAzimuth.ObjGrafico.FiltroAzimuth = this.ObjFiltroAzimuth.Filtro
        this.ObjFiltroAzimuth.Popup = false
      },

      AnnullaModificaAssi()
      {
        this.ObjModificaAssi.PopupAperto = false
      },

      ConfermaModificaAssi()
      {
        this.ObjModificaAssi.PopupAperto = false
        this.ObjModificaAssi.ModificaEffettuata = true
      },

      GetDimensioniGraficiVerticali(Ridotto)
      {
        // DA USARE CON IL GRAFICO ESTENSIMETRI
        // let Estensione = 13.6
        // if (Ridotto)
        //   Estensione = 9.2
        // if (!this.Catena.EstensimetroPresente)
        //   Estensione += Estensione / 7 
        // Estensione += '%'  
        // return {'width' : this.Mobile ? '100%' : Estensione }

        let Estensione = 15.6
        if (Ridotto)
          Estensione = 11
        if (!this.Catena.EstensimetroPresente)
          Estensione += Estensione / 6
        Estensione += '%'  
        return {'width' : this.Mobile ? '100%' : Estensione }
      },

      GetDimensioniVociMenu(Dimensione)
      {
        return {'width' : this.Mobile ? '100%' : Dimensione}
      },

      FormattaData(Data)
      {
        let [DatePart, Orario] = Data.split(' ');
        let [anno, mese, giorno] = DatePart.split('-');
        return `${giorno}-${mese}-${anno} ${Orario}`;
      },

      GetDatiTableIngrandimento()
      {
        let Campi = []
        let Dati  = []
        let ModelObjDato = {}
        if (this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Deformazione && this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Piezometro)
        {
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), Dimensione: '10%'})
          ModelObjDato.Modulo = -1
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Profondita  = 0
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Pitch = 0
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Roll  = 0
        }
        switch (this.ObjIngrandimento.TipoGrafico)
        {
          case (TIPI_GRAFICI.Polare) :
          { 
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_EST',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostEst = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_NORD',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostNord = 0
            break
          }
          case (TIPI_GRAFICI.SpostEst) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_EST',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostEst = 0
            break
          }
          case (TIPI_GRAFICI.SpostNord) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_NORD',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostNord = 0
            break
          }
          case (TIPI_GRAFICI.SpostTot) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_SPOST_TOT',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.SpostTotale = 0
            break
          }
          case (TIPI_GRAFICI.SpostAzimuth) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_AZIMUT',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Azimuth = 0
            break
          }
          case (TIPI_GRAFICI.Temperatura) :
          {
            break
          }
          case (TIPI_GRAFICI.Piezometro) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), Dimensione: '10%'})
            ModelObjDato.Modulo = -1
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Profondita  = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PRESSIONE',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_ACQUA',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Pressione = 0
            break    
          }
          case (TIPI_GRAFICI.Deformazione) :
          {
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), Dimensione: '10%'})
            ModelObjDato.Modulo = -1
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Deformazione = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_TEMP',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Temperatura = 0
            Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']', Dimensione: null})
            ModelObjDato.Profondita = 0
            break              
          }
        }

        if (this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Deformazione && this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Piezometro)
        {
          Campi.push({Campo: this.GetTraduzioneLabel('Generic','TKN_TEMP',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']', Dimensione: null})
          ModelObjDato.Temperatura  = 0
        }

        let Dimensione = (90 / (Campi.length - 1)) + '%'
        Campi.forEach((element) => {element.Dimensione == null ? element.Dimensione = Dimensione : element.Dimensione = '10%'})
        this.ObjIngrandimento.Campi = Campi
        
        for (let i = 0; i < this.ObjIngrandimento.ProprietaGrafiche.__GruppiPunti.length; i++)
        {
          let GruppoPunti = this.ObjIngrandimento.ProprietaGrafiche.__GruppiPunti[i]
          Dati.push({Separatore : true, Voci : [this.FormattaData(GruppoPunti.__Data)]})   

          for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          {
            let Punto     = GruppoPunti.__Punti[j]
            let ObjDato   = {Separatore : false, Voci : []}

            for (let Property in ModelObjDato)
            {
              if (this.ObjIngrandimento.TipoGrafico != TIPI_GRAFICI.Piezometro)
              {
                switch(Property)
                {
                  case 'Profondita'  : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)); break
                  case 'Pitch'       : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(3)); break
                  case 'Roll'        : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(3)); break
                  case 'SpostEst'    : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)); break
                  case 'SpostNord'   : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)); break
                  case 'SpostTotale' : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)); break
                  case 'Azimuth'     : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(2)); break
                  case 'Temperatura' : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)); break
                  case 'Pressione'   : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)); break
                  default            : ObjDato.Voci.push(Punto[Property]); break
                }
              }
              else
              {
                for (let k = 0; k < this.ObjIngrandimento.CatenaInfo.Moduli.length; k++)
                {
                  let Modulo = this.ObjIngrandimento.CatenaInfo.Moduli[k]
                  
                  if(Punto.Pressione !== null && Modulo.MODULO == Punto.Modulo && Modulo.PIEZOMETRO == 'T')
                  {
                    switch(Property)
                    {
                      case 'Profondita' : ObjDato.Voci.push(parseFloat(Punto[Property]).toFixed(1)); break
                      case 'Pressione'  : ObjDato.Voci.push((parseFloat(Punto[Property]) / 1000).toFixed(2)); break
                      default           : ObjDato.Voci.push(Punto[Property]); break
                    }
                  }
                }
              }
            }
            Dati.push(ObjDato)
          }
        }
        this.ObjIngrandimento.Dati = Dati
      },

      RimuoviElemento(Elemento)
      {
        let index = this.ObjAbbinati.LsGraficiAbbinatiTmp.findIndex((element) => {return element.DataCompleta == Elemento.DataCompleta})
        if (index != -1)
          this.ObjAbbinati.LsGraficiAbbinatiTmp.splice(index, 1)
      },

      RimuoviElementoDaTabella(Elemento)
      {
        let index = this.ObjAbbinati.LsGraficiAbbinati.findIndex((element) => {return element.DataCompleta == Elemento.DataCompleta})
        if (index != -1)
          this.ObjAbbinati.LsGraficiAbbinati.splice(index, 1)
        this.CaricaDatiCatena()
      },

      RimuoviAllineamento()
      {
        this.ObjAllineamento.DataAllineamento = null
        this.ObjAllineamento.OrarioAllineamento = null
        this.ObjAllineamento.ListaOre = []
        this.ObjAllineamento.DataOraAllineamento = null
        this.ObjAllineamento.PrettyDataAllineamento = ''
        this.CaricaDatiCatena()
      },

      TrovaCampioniAllineamento()
      {
        if (!this.RicercaInCorso)
        {
          this.RicercaInCorso = true
          this.ObjAllineamento.ListaOre = []
          let Self = this
          let Dal = this.ObjAllineamento.DataAllineamento + ' 00:00:00' 
          let Al  = this.ObjAllineamento.DataAllineamento + ' 23:59:59'
          SystemInformation.AdvQuerySiti.GetSQL("Catene",{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito},
                                                function(Results)
                                                {
                                                  let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrariAll");
                                                  if(ArrayInfo != undefined)
                                                  {
                                                    Self.ObjAllineamento.Trovato = false
                                                    if (ArrayInfo.length > 0)
                                                    {
                                                      for (let i = 0; i < ArrayInfo.length; i++)
                                                      {
                                                        let Data = new Date(ArrayInfo[i].DATA)
                                                        let Ora = Data.getHours()
                                                        if (Ora < 10)
                                                          Ora = '0' + Ora
                                                        let Minuti = Data.getMinutes()
                                                        if (Minuti < 10)
                                                          Minuti = '0' + Minuti
                                                        Self.ObjAllineamento.ListaOre.push(Ora + ':' + Minuti)
                                                      }
                                                      if (Self.ObjAllineamento.ListaOre.length > 0)
                                                      {
                                                        Self.ObjAllineamento.OrarioAllineamento = Self.ObjAllineamento.ListaOre[0]
                                                        Self.ObjAllineamento.Trovato = true
                                                      }
                                                    }
                                                  }
                                                  else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                                  Self.RicercaInCorso = false
                                                },
                                                function(HTTPError,SubHTTPError)
                                                {
                                                  SystemInformation.HandleError(HTTPError,SubHTTPError)
                                                }, 'SelectOrariAllineamento');
        }

        // SystemInformation.AdvQuery.ExecuteExternalScript('ExtraGetOrariAllineamento',{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito, FusoUtente : SystemInformation.UserInformation.FusoOrario, Catena : -1},
        //                                                   function(Answer) 
        //                                                   {
        //                                                     if(Answer != undefined)
        //                                                     {
        //                                                       if (Answer.QueryData.length > 0)
        //                                                       {
        //                                                         for (let i = 0; i < Answer.QueryData.length; i++)
        //                                                         {
        //                                                           let Data = new Date(Answer.QueryData[i])
        //                                                           let Ora = Data.getHours()
        //                                                           if (Ora < 10)
        //                                                             Ora = '0' + Ora
        //                                                           let Minuti = Data.getMinutes()
        //                                                           if (Minuti < 10)
        //                                                             Minuti = '0' + Minuti
        //                                                           Self.ObjAllineamento.ListaOre.push(Ora + ':' + Minuti)
        //                                                         }
        //                                                         if (Self.ObjAllineamento.ListaOre.length > 0)
        //                                                         {
        //                                                           Self.ObjAllineamento.OrarioAllineamento = Self.ObjAllineamento.ListaOre[0]
        //                                                         }
        //                                                       }
        //                                                     }
        //                                                     else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
        //                                                   },
        //                                                   function(HTTPError,SubHTTPError,Response)
        //                                                   {
        //                                                     SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
        //                                                   })
      },

      TrovaCampioniPerData(DataPassata = null, OnSuccess = null)
      {
        this.ObjAbbinati.ListaOre = []
        let Self = this
        let Dal = this.ObjAbbinati.NuovaDataAbbinato + ' 00:00:00' 
        let Al  = this.ObjAbbinati.NuovaDataAbbinato + ' 23:59:59'
        if (DataPassata != null)
        {
          Dal = DataPassata + ' 00:00:00'
          Al  = DataPassata + ' 23:59:59'
        }

        SystemInformation.AdvQuerySiti.GetSQL("Catene",{Catena : this.ChiaveCatena, Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito},
                                              function(Results)
                                              {
                                                let ArrayInfo = SystemInformation.AdvQuerySiti.FindResults(Results,"GetOrari");
                                                if(ArrayInfo != undefined)
                                                {
                                                  if (ArrayInfo.length > 0)
                                                  {
                                                    for (let i = 0; i < ArrayInfo.length; i++)
                                                    {
                                                      let Data = new Date(ArrayInfo[i].DATA)
                                                      let Ora = Data.getHours()
                                                      if (Ora < 10)
                                                        Ora = '0' + Ora
                                                      let Minuti = Data.getMinutes()
                                                      if (Minuti < 10)
                                                        Minuti = '0' + Minuti
                                                      Self.ObjAbbinati.ListaOre.push(Ora + ':' + Minuti)
                                                    }
                                                    if (Self.ObjAbbinati.ListaOre.length > 0)
                                                    {
                                                      Self.ObjAbbinati.NuovoOrarioAbbinato = Self.ObjAbbinati.ListaOre[0]
                                                      Self.ObjAbbinati.DatiTrovati = true 
                                                    }
                                                    else
                                                    {
                                                      Self.ObjAbbinati.DatiTrovati = false
                                                    }
                                                    if (OnSuccess != null)
                                                    {
                                                      OnSuccess()
                                                    }
                                                  }
                                                  else
                                                  {
                                                    Self.PopupWarning = true
                                                    Self.TestoWarning = Self.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_WAR_NO_CAMP_TROVATO',Self.LinguaUtente)
                                                  }
                                                }
                                                else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
                                              },
                                              function(HTTPError,SubHTTPError)
                                              {
                                                SystemInformation.HandleError(HTTPError,SubHTTPError)
                                              }, 'SelectDateCampioni');

        // SystemInformation.AdvQuery.ExecuteExternalScript('ExtraGetOrariAllineamento',{Dal : Dal, Al : Al, DMSEWSito : this.ChiaveSito, FusoUtente : SystemInformation.UserInformation.FusoOrario, Catena : this.ChiaveCatena},
        //                                                   function(Results)
        //                                                   {
        //                                                     if(Results != undefined)
        //                                                     {
        //                                                       if (Results.QueryData.length > 0)
        //                                                       {
        //                                                         for (let i = 0; i < Results.QueryData.length; i++)
        //                                                         {
        //                                                           let Data = new Date(Results.QueryData[i])
        //                                                           let Ora = Data.getHours()
        //                                                           if (Ora < 10)
        //                                                             Ora = '0' + Ora
        //                                                           let Minuti = Data.getMinutes()
        //                                                           if (Minuti < 10)
        //                                                             Minuti = '0' + Minuti
        //                                                           Self.ObjAbbinati.ListaOre.push(Ora + ':' + Minuti)
        //                                                         }
        //                                                         if (Self.ObjAbbinati.ListaOre.length > 0)
        //                                                         {
        //                                                           Self.ObjAbbinati.NuovoOrarioAbbinato = Self.ObjAbbinati.ListaOre[0]
        //                                                           Self.ObjAbbinati.DatiTrovati = true 
        //                                                         }
        //                                                         else
        //                                                         {
        //                                                           Self.ObjAbbinati.DatiTrovati = false
        //                                                         }
        //                                                         if (OnSuccess != null)
        //                                                         {
        //                                                           OnSuccess()
        //                                                         }
        //                                                       }
        //                                                       else
        //                                                       {
        //                                                         Self.PopupWarning = true
        //                                                         Self.TestoWarning = 'Nessun campione trovato per la data selezionata'
        //                                                       }
        //                                                     }
        //                                                     else SystemInformation.HandleError("Impossibile ottenere i dati della catena");
        //                                                   },
        //                                                   function(HTTPError,SubHTTPError,Response)
        //                                                   {
        //                                                     SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
        //                                                   })
      },
      
      // ConfermaModificaAllineamento()
      // {
      //   this.ObjAllineamento.DataAllineamento = this.ObjAllineamento.NuovaDataAllineamento
      //   this.ObjAllineamento.PrettyDataAllineamento = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjAllineamento.DataAllineamento))
      //   this.CaricaDatiCatena()
      //   this.AnnullaModificaAllineamento()
      // },

      // AnnullaModificaAllineamento()
      // {
      //   this.PopupModificaAllineamento = false
      //   this.ObjAllineamento.NuovaDataAllineamento = ''
      // },

      AnnullaAllineamento()
      {
        this.PopupSelezioneAllineamento = false
      },

      ConfermaAllineamento()
      {
        this.ObjAllineamento.DataOraAllineamento = this.ObjAllineamento.DataAllineamento + ' ' + this.ObjAllineamento.OrarioAllineamento
        this.ObjAllineamento.PrettyDataAllineamento = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjAllineamento.DataOraAllineamento))
        this.CaricaDatiCatena()
        this.AnnullaAllineamento()
      },

      ApriPopupGraficiAbbinati()
      {
        this.ObjAbbinati.LsGraficiAbbinatiTmp = TZGenericFunct.GetCopyOfObject(this.ObjAbbinati).LsGraficiAbbinati
        this.PopupGraficiAbbinati = true
      },

      AggiungiDataAbbinato(ConfermaOra = false)
      {
        let Data = this.ObjAbbinati.NuovaDataAbbinato + ' ' + this.ObjAbbinati.NuovoOrarioAbbinato
        let index = this.ObjAbbinati.LsGraficiAbbinatiTmp.findIndex((element) => {return element.DataCompleta == Data})
        if (index == -1)
        {
          let ObjVoce = {
                          DataCompleta       : Data,
                          PrettyDataCompleta : TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(Data)),
                          Data               : this.ObjAbbinati.NuovaDataAbbinato,
                          PrettyData         : TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data)),
                          Ora                : this.ObjAbbinati.NuovoOrarioAbbinato,
                          Colore             : '#0000FF',
                          Falda              : true,
                          Visibile           : true
                        }
          this.ObjAbbinati.LsGraficiAbbinatiTmp.push(ObjVoce)
          let Colore = null
          while (Colore == null)
          {
            if (COLORI_DEFAULT_GRAFICI.length > this.ObjAbbinati.LsGraficiAbbinatiTmp.length - COLORI_DEFAULT_GRAFICI.length * index)
            {
              Colore = COLORI_DEFAULT_GRAFICI[this.ObjAbbinati.LsGraficiAbbinatiTmp.length - COLORI_DEFAULT_GRAFICI.length * index]
            }
            index++
          }
          ObjVoce.Colore = Colore
          this.PopupWarning = false
          if (ConfermaOra)
            this.ConfermaAbbinati()
        }
        else
        {
          this.TestoWarning = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_WAR_GIA_PRESENTE',this.LinguaUtente)
          this.PopupWarning = true
        }
        this.ObjAbbinati.ListaOre = []
        this.ObjAbbinati.NuovaDataAbbinato = this.GetDataOdierna()
        this.ObjAbbinati.NuovoOrarioAbbinato = null
      },

      AggiungiNuovoGrafico(Giorni, ConfermaOra = false)
      {
        if (ConfermaOra)
          this.ObjAbbinati.LsGraficiAbbinatiTmp = TZGenericFunct.GetCopyOfObject(this.ObjAbbinati).LsGraficiAbbinati
        let UltimaDataDateObj = new Date(this.UltimaData.Data)
        let Data = TZDateFunct.ChangeDate(UltimaDataDateObj, 'day', -1 * Giorni)
        this.ObjAbbinati.NuovaDataAbbinato = TZDateFunct.FormatDateTime('yyyy-mm-dd', Data)
        this.TrovaCampioniPerData(TZDateFunct.FormatDateTime('yyyy-mm-dd', Data),
                                  () =>
                                  {
                                    if (this.ObjAbbinati.ListaOre.length > 0)
                                    {
                                      let Orario = TZDateFunct.FormatDateTime('hh:nn', UltimaDataDateObj)
                                      if (this.ObjAbbinati.ListaOre.includes(Orario))
                                        this.ObjAbbinati.NuovoOrarioAbbinato = Orario
                                      this.PopupWarning = false
                                      this.AggiungiDataAbbinato(ConfermaOra)
                                    }
                                    else
                                    {
                                      this.TestoWarning = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_WAR_NO_GRAF_TROVATO',this.LinguaUtente)
                                      this.PopupWarning = true
                                    }
                                  })
      },

      // GetMaxMin(Differenziale)
      // {
      //   for (let j = 0; j < this.Catena.DatiCatena.Spostamenti.Date.length; j++)
      //   { 
      //     let ObjData = this.Catena.DatiCatena.Spostamenti.Date[j]
      //     let DatiGraficiElemento = this.ObjAbbinati.LsGraficiAbbinati.find((element) => {return element.DataCompleta == ObjData.Data})
      //     if (DatiGraficiElemento != undefined)
      //     {
      //       ObjData.Colore = DatiGraficiElemento.Colore
      //       ObjData.Markup = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, ObjCatena.GRAPH_MARKUP_WIDTH)
      //       ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', ObjCatena.GRAPH_MARKUP_WIDTH)   
      //     }
      //     let SumSpostEst  = 0
      //     let SumSpostNord = 0
      //     let SumSpostAllineatoNord = 0
      //     let SumSpostAllineatoEst  = 0
      //     let Spostamenti = Self.Catena.DatiCatena.Spostamenti.Date[j].Moduli
      //     for (let k = 0; k < Spostamenti.length; k++)
      //     {
      //       let Spostamento = Spostamenti[k]
      //       let Allineamento = null
      //       if (ObjCatena.Allineamento.Moduli != null)
      //         Allineamento = ObjCatena.Allineamento.Moduli[k]
            
      //       if (!Differenziale)
      //       {
      //         SumSpostEst  = SumSpostEst - Spostamento.SpostamentoEst / 1000
      //         SumSpostNord = SumSpostNord - Spostamento.SpostamentoNord / 1000
      //       }
      //       else
      //       {
      //         SumSpostEst  = Spostamento.SpostamentoEst / 1000
      //         SumSpostNord = Spostamento.SpostamentoNord / 1000
      //       }
            
      //       if (Allineamento != null)
      //       {
      //         SumSpostAllineatoNord = SumSpostAllineatoNord - Allineamento.SpostamentoNord / 1000
      //         SumSpostAllineatoEst  = SumSpostAllineatoEst - Allineamento.SpostamentoEst / 1000
      //         if (Math.abs(SumSpostEst - SumSpostAllineatoEst) > MaxMinGraph)
      //           MaxMinGraph = Math.abs(SumSpostEst - SumSpostAllineatoEst)
      //         if (Math.abs(SumSpostNord - SumSpostAllineatoNord) > MaxMinGraph)
      //           MaxMinGraph = Math.abs(SumSpostNord - SumSpostAllineatoNord)
      //       }
      //       else
      //       {
      //         if (Math.abs(SumSpostEst) > MaxMinGraph)
      //           MaxMinGraph = Math.abs(SumSpostEst)
      //         if (Math.abs(SumSpostNord) > MaxMinGraph)
      //           MaxMinGraph = Math.abs(SumSpostNord)
      //       }
      //     }
      //   }
      // },

      // ApriDettaglio(TipoGrafico)
      // {
      //   this.DettaglioGrafico = true
      //   switch (TipoGrafico)
      //   {
      //     case (TIPI_GRAFICI.Polare) :
      //     {
            
      //       break
      //     }
      //     case (TIPI_GRAFICI.SpostEst) :
      //     {
      //       this.GraficoCompilato.CompilaGraficoSpostEst()       
      //       break
      //     }
      //     case (TIPI_GRAFICI.SpostNord) :
      //     {
      //       this.GraficoCompilato.CompilaGraficoSpostNord()       
      //       break
      //     }
      //     case (TIPI_GRAFICI.SpostTot) :
      //     {
      //       this.GraficoCompilato.CompilaGraficoSpostTot()       
      //       break
      //     }
      //     case (TIPI_GRAFICI.SpostAzimuth) :
      //     {
      //       this.GraficoCompilato.CompilaGraficoSpostAzimuth()       
      //       break
      //     }
      //     case (TIPI_GRAFICI.Temperatura) :
      //     {
      //       this.GraficoCompilato.CompilaGraficoTemperatura()       
      //       break
      //     }
      //     case (TIPI_GRAFICI.Deformazione) :
      //     {
      //       this.GraficoCompilato.CompilaGraficoDeformazione()       
      //       break              
      //     }
      //   }
      // },

      ToggleUltimaData()
      {
        let Index = this.Catena.DatiCatena.Spostamenti.Date.findIndex((Elemento) => { return Elemento.Ultima })

        if(this.MostraUltimo)
        {
          if(Index == -1)
            this.Catena.DatiCatena.Spostamenti.Date.unshift(this.UltimaData)
        }
        else
        {
          if(Index != -1)
          {
            this.UltimaData = this.Catena.DatiCatena.Spostamenti.Date[Index]
            this.Catena.DatiCatena.Spostamenti.Date.splice(Index, 1)
          }
        }

        this.GraficiChange++
      },

      ConfermaAbbinati()
      {
        this.ObjAbbinati.LsGraficiAbbinati = TZGenericFunct.GetCopyOfObject(this.ObjAbbinati).LsGraficiAbbinatiTmp
        this.PopupGraficiAbbinati = false
        this.ObjAbbinati.LsGraficiAbbinatiTmp = []
        this.ObjAbbinati.NuovaDataAbbinato = this.GetDataOdierna()
        this.ObjAbbinati.NuovoOrarioAbbinato = 0
        this.CaricaDatiCatena()
      },

      AnnullaModificaAbbinati()
      {
        this.PopupGraficiAbbinati = false
        this.ObjAbbinati.LsGraficiAbbinatiTmp = []
        this.ObjAbbinati.NuovaDataAbbinato = this.GetDataOdierna()
        this.ObjAbbinati.NuovoOrarioAbbinato = 0
        if (this.Mobile)
          setTimeout(() => {this.GraficiChange++}, 1)
      },

      CaricaDatiCatena(OnSuccess = undefined)
      {
        SystemInformation.DatiCatena = null
        this.MostraGrafici           = false

        let Self = this
        // let MaxMinGraph = 0
        // let Parametri = {Chiave : this.ChiaveSito, ChiaveCatena : this.ChiaveCatena, Allineamento : TZDateFunct.ChangeDate(new Date(this.ObjAllineamento.DataOraAllineamento), 'hour', 1)}
        let Parametri = {
                          Chiave          : this.ChiaveSito,
                          ChiaveCatena    : this.ChiaveCatena,
                          Allineamento    : this.ObjAllineamento.DataOraAllineamento,
                          MediaAritmetica : this.MediaAttiva
                        }

        if(this.ObjAbbinati.LsGraficiAbbinati.length != 0)
        {
          Parametri.Date  = []
          Parametri.Falde = []
          
          for (let i = 0; i < this.ObjAbbinati.LsGraficiAbbinati.length; i++)
          {
            Parametri.Date.push(this.ObjAbbinati.LsGraficiAbbinati[i].DataCompleta)
            Parametri.Falde.push(this.ObjAbbinati.LsGraficiAbbinati[i].Falda)
          }
        }

        if(this.MediaAttiva)
        {
          let DataDal    = this.ObjMedia.Data + ' ' + this.ObjMedia.Ora

          Parametri.Date = []
          Parametri.Date.push(DataDal)
          Parametri.Date.push(TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn', TZDateFunct.ChangeDate(new Date(DataDal), 'hour', this.ObjMedia.Intervallo)))
        }

        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraDatiCatene', Parametri, function(Answer) 
        {
          let ObjCatena = Answer.QueryData[0]

          Self.Catena.DatiCatena                           = {}
          Self.Catena.DatiCatena.CHIAVE_SITO               = Self.ChiaveSito
          Self.Catena.DatiCatena.CHIAVE                    = Self.ChiaveCatena
          Self.Catena.DatiCatena.DESCRIZIONE               = TSchedaGenerica.DisponiFromString(ObjCatena.DESCRIZIONE)
          Self.Catena.DatiCatena.PLUVIOMETRO               = TSchedaGenerica.DisponiFromBoolean(ObjCatena.PLUVIOMETRO)
          Self.Catena.DatiCatena.ANEMOMETRO                = TSchedaGenerica.DisponiFromBoolean(ObjCatena.ANEMOMETRO)
          Self.Catena.DatiCatena.TERMOMETRO                = TSchedaGenerica.DisponiFromBoolean(ObjCatena.TERMOMETRO)
          Self.Catena.DatiCatena.INTERPOLAZIONE            = TSchedaGenerica.DisponiFromBoolean(ObjCatena.INTERPOLAZIONE)

          if(Self.Catena.DatiCatena.TERMOMETRO || Self.Catena.DatiCatena.ANEMOMETRO || Self.Catena.DatiCatena.PLUVIOMETRO)
            Self.CurrentObjPresenzaMenu.VisualizzaStazioneMeteo = true
          
          Self.Catena.DatiCatena.IDENTIFICATIVO            = TSchedaGenerica.DisponiFromString(ObjCatena.IDENTIFICATIVO)
          Self.Catena.DatiCatena.FUORI_SERVIZIO            = TSchedaGenerica.DisponiFromBoolean(ObjCatena.FUORI_SERVIZIO)
          Self.Catena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO   = TSchedaGenerica.DisponiFromString(ObjCatena.TIPO_GRAFICO_PIEZOMETRO)
          Self.Catena.DatiCatena.PIEZOMETRO_DI_RIFERIMENTO = TSchedaGenerica.DisponiFromInteger(ObjCatena.PIEZOMETRO_DI_RIFERIMENTO)
          Self.Catena.DatiCatena.MinProfondita = TSchedaGenerica.DisponiFromDouble(ObjCatena.MinProfondita, 2)
          Self.Catena.DatiCatena.MaxProfondita = TSchedaGenerica.DisponiFromDouble(ObjCatena.MaxProfondita, 2)
          Self.Catena.DatiCatena.Spostamenti = ObjCatena.Spostamenti
          Self.Catena.DatiPDF = []
          Self.Catena.Descrizione = TSchedaGenerica.DisponiFromString(ObjCatena.DESCRIZIONE)
          let LsInfoCatena  = [
                                // {Descrizione : 'Committente', Valore : 'Chiedere a Max'},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_SITO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.SITO)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_PROGETTO_ESTESO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.PROGETTO)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_INT_MONITORAGGIO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.MONITORAGGIO)},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_INSTALLAZIONE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_INSTALLAZIONE)))},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_CALIBRAZIONE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_CALIBRAZIONE)))},
                                {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_NOTE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.NOTE)}
                              ]
          let LsInfoCatenaLeft  = [
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_SITO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.SITO)},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_PROGETTO_ESTESO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.PROGETTO)},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_INT_MONITORAGGIO',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.MONITORAGGIO)}, 
                                  ]
          let LsInfoCatenaRight = [
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_INSTALLAZIONE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_INSTALLAZIONE)))},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_DATA_CALIBRAZIONE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromDate(TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(ObjCatena.DATA_CALIBRAZIONE)))},
                                    {Descrizione : Self.GetTraduzioneLabel('Generic','TKN_NOTE',Self.LinguaUtente), Valore : TSchedaGenerica.DisponiFromString(ObjCatena.NOTE)}, 
                                  ]

          Self.Catena.LsInfoCatena      = LsInfoCatena
          Self.Catena.LsInfoCatenaLeft  = LsInfoCatenaLeft
          Self.Catena.LsInfoCatenaRight = LsInfoCatenaRight

          Self.Catena.DatiCatena.Allineamento = ObjCatena.Allineamento

          if(Self.Catena.DatiCatena.Spostamenti != undefined)
          {
            let index = Self.Catena.DatiCatena.Spostamenti.Date.findIndex((element) => {return element.Ultima})
            
            if(index != -1)
            {
              let ObjData = Self.Catena.DatiCatena.Spostamenti.Date[index]

              ObjData.Colore            = Self.ObjColore.ColoreScelto              
              ObjData.Markup            = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, ObjCatena.GRAPH_MARKUP_WIDTH)
              ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', ObjCatena.GRAPH_MARKUP_WIDTH)
              
              Self.PrettyUltimaData     = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(Self.Catena.DatiCatena.Spostamenti.Date[index].Data))
              Self.UltimaData           = Self.Catena.DatiCatena.Spostamenti.Date[index]
              Self.ObjMedia.Data        = TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Self.Catena.DatiCatena.Spostamenti.Date[index].Data))
              Self.ObjMedia.Ora         = TZDateFunct.FormatDateTime('hh:nn', new Date(Self.Catena.DatiCatena.Spostamenti.Date[index].Data))
              Self.ObjMedia.Intervallo  = 24
            }
            
            if(!Self.MostraUltimo && !Self.MediaAttiva)
              Self.Catena.DatiCatena.Spostamenti.Date.splice(index, 1)
            
            for(let j = 0; j < Self.Catena.DatiCatena.Spostamenti.Date.length; j++)
            {
              let ObjData             = Self.Catena.DatiCatena.Spostamenti.Date[j]
              let DatiGraficiElemento = Self.ObjAbbinati.LsGraficiAbbinati.find((Elemento) => { return Elemento.DataCompleta == ObjData.Data })
              
              if(DatiGraficiElemento != undefined)
              {
                ObjData.Colore            = DatiGraficiElemento.Colore
                ObjData.Markup            = SystemInformation.GetBlobSVGMarkup('CerchioPieno', ObjData.Colore, ObjCatena.GRAPH_MARKUP_WIDTH)
                ObjData.MarkupHighlighted = SystemInformation.GetBlobSVGMarkup('CerchioPieno', 'red', ObjCatena.GRAPH_MARKUP_WIDTH)
              }
            }
          }

          Self.Catena.DatiGrafici = {
                                      TITLE_COLOR          : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_TITLE_COLOR),
                                      TITLE_FONT_SIZE      : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_TITLE_FONT_SIZE),
                                      BACKGROUND           : Self.ColoreGrafico.Sfondo,        
                                      COLOR                : Self.ColoreGrafico.Grafico,
                                      MARKUP               : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_MARKUP),
                                      MARKUP_WIDTH         : 5,
                                      PEN_WIDTH            : 2,
                                      DRAW_TITLE_STROKE    : TSchedaGenerica.DisponiFromBoolean(ObjCatena.GRAPH_DRAW_TITLE_STROKE),
                                      COLOR_TITLE_STROKE   : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_COLOR_TITLE_STROKE),
                                      DRAW_BORDERS         : false,
                                      AXES_COLOR           : Self.ColoreGrafico.Griglia,
                                      AXES_PEN_WIDTH       : 1,
                                      AXES_MIN             : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_MAX) * -1,
                                      AXES_MAX             : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_MAX),
                                      NOTCH_SIZE           : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_NOTCH_SIZE),
                                      NOTCH_FONT_SIZE      : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_NOTCH_FONT_SIZE),
                                      NOTCH_PEN_WIDTH      : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_NOTCH_PEN_WIDTH),
                                      NOTCH_COLOR          : Self.ColoreGrafico.Griglia,
                                      AXES_FONT_SIZE       : TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_AXES_FONT_SIZE),
                                      AXES_FONT_COLOR      : Self.ColoreGrafico.Griglia,
                                      AXES_LABEL_TYPE      : TSchedaGenerica.DisponiFromString(ObjCatena.GRAPH_AXES_LABEL_TYPE),                                      
                                      AXES_LABELS_USE_BOLD : TSchedaGenerica.DisponiFromBoolean(ObjCatena.GRAPH_AXES_LABELS_USE_BOLD),
                                      DRAW_LATERAL_LABELS  : false,
                                      DRAW_NOTCH_LABELS    : TSchedaGenerica.DisponiFromBoolean(ObjCatena.GRAPH_DRAW_NOTCH_LABELS),
                                    }
          Self.Catena.Moduli = []

          for(let j = 0; j < ObjCatena.ModuliConfig.length; j++)
          {
            let Modulo = ObjCatena.ModuliConfig[j]
            let ObjModulo = {}
            ObjModulo = {
                          CATENA                  : Modulo.CATENA,
                          MODULO                  : Modulo.MODULO,
                          INCLINOMETRO            : Modulo.INCLINOMETRO,
                          ESTENSIMETRO            : Modulo.ESTENSIMETRO,
                          PIEZOMETRO              : Modulo.PIEZOMETRO,
                          TERMOMETRO              : Modulo.TERMOMETRO,
                          ACCELEROMETRO           : Modulo.ACCELEROMETRO,
                          MAGNETOMETRO            : Modulo.MAGNETOMETRO,
                          PROFONDITA_TESTA        : Modulo.PROFONDITA_TESTA,
                          PROFONDITA_CODA         : Modulo.PROFONDITA_CODA,
                          LUNGHEZZA_SPEZZONE      : Modulo.LUNGHEZZA_SPEZZONE,
                          ORIENTAMENTO            : Modulo.ORIENTAMENTO,
                          SEGMENTO_DEFORMAZIONE_A : Modulo.SEGMENTO_DEFORMAZIONE_A,
                          SEGMENTO_DEFORMAZIONE_B : Modulo.SEGMENTO_DEFORMAZIONE_B,
                        }
            Self.Catena.Moduli.push(ObjModulo)
          }
          Self.Catena.DatiCatena.Piezometro = []
          for (let j = 0; j < ObjCatena.PiezometroConfig.length; j++)
          {
            let Piezometro = ObjCatena.PiezometroConfig[j]
            let ObjPiezometro = {}
            ObjPiezometro = {
                              NUMERO_PIEZOMETRO       : Piezometro.NUMERO_PIEZOMETRO,
                              COLORE                  : Piezometro.COLORE,
                              MOSTRA_PACKER           : Piezometro.MOSTRA_PACKER,
                            }
            Self.Catena.DatiCatena.Piezometro.push(ObjPiezometro)
          }

          Self.Catena.DatiCatena.Packer = []
          for (let j = 0; j < ObjCatena.PackerConfig.length; j++)
          {
            let Packer = ObjCatena.PackerConfig[j]
            let ObjPacker = {}
            ObjPacker = {
                          DESCRIZIONE             : Packer.DESCRIZIONE,
                          DALLA_PROFONDITA        : Packer.DALLA_PROFONDITA,
                          ALLA_PROFONDITA         : Packer.ALLA_PROFONDITA,
                          COLORE                  : Packer.COLORE,
                        }
            Self.Catena.DatiCatena.Packer.push(ObjPacker)
          }

          Self.Catena.Allarmi = []
          Self.Catena.TipiAllarmiAttivi = []

          Self.Catena.MouseOverOnCoords = {}
          Self.Catena.DimensioniRelative =  {
                                              POS_X : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_POS_X, 5),
                                              POS_Y : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_POS_Y, 5),
                                              LARGHEZZA : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_LARGHEZZA, 5),
                                              ALTEZZA   : TSchedaGenerica.DisponiFromDouble(ObjCatena.GRAPH_ALTEZZA, 5)
                                            }
          Self.Catena.MouseInfo.Coordinates = {x: 0, y: 0}
          Self.Catena.MouseInfo.Detail =  {
                                            xStart  : 0,
                                            yStart  : 0,
                                            xAngolo : 0,
                                            yAngolo : 0, 
                                            width   : 0, 
                                            height  : 0
                                          }
          Self.Catena.MouseInfo.Enlarge = {
                                            xStart : 0,
                                            yStart : 0,
                                          }
          Self.Catena.MouseInfo.Indice = TSchedaGenerica.DisponiFromInteger(ObjCatena.GRAPH_ORDINAMENTO)
          Self.Catena.MouseInfo.MouseDown = false
          Self.Catena.MouseInfo.MouseDownEnlarge = false
          // Self.MaxMinGraph = MaxMinGraph
          Self.AdattaGrafici()
          Self.Catena.DatiGrafici.AXES_MAX = TZMathFunct.GetMultiplo(Self.Catena.DatiGrafici.AXES_MAX, Self.Catena.DatiGrafici.NOTCH_SIZE, 'Difetto')
          
          if (OnSuccess != undefined)
          {
            OnSuccess()
          }
          Self.MostraGrafici = true
          Self.CaricamentoDatiCatena = false
        },
        function(ErrorMessage,DescrErrore)
        {
          Self.CaricamentoDatiCatena = false
          alert(ErrorMessage + '[' + DescrErrore + ']')
        }) 
      },
      OnClickChiudiPopup()
      {
        this.PopupStorici = false
      },

      OnClickChiudiPopupTensioneAssorb()
      {
        this.PopupTensioneAssorbimento = false
      },

      OnClickChiudiPopupStazioneMeteo()
      {
        this.PopupStazioneMeteo = false
      },

      OnClickApriPopupTensioneAssorbimento()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false
            OggettoModulo.Colore       = TZGenericFunct.GenerateRandomColor(['#FFFFFF, #ffffff'])

            //Dati moduli presenti nella catena
            // CATENA                  : Modulo.CATENA,
            // MODULO                  : Modulo.MODULO,
            // INCLINOMETRO            : Modulo.INCLINOMETRO,
            // ESTENSIMETRO            : Modulo.ESTENSIMETRO,
            // PIEZOMETRO              : Modulo.PIEZOMETRO,
            // TERMOMETRO              : Modulo.TERMOMETRO,
            // ACCELEROMETRO           : Modulo.ACCELEROMETRO,
            // MAGNETOMETRO            : Modulo.MAGNETOMETRO,
            // PROFONDITA_TESTA        : Modulo.PROFONDITA_TESTA,
            // PROFONDITA_CODA         : Modulo.PROFONDITA_CODA,
            // LUNGHEZZA_SPEZZONE      : Modulo.LUNGHEZZA_SPEZZONE,
            // ORIENTAMENTO            : Modulo.ORIENTAMENTO,
            // SEGMENTO_DEFORMAZIONE_A : Modulo.SEGMENTO_DEFORMAZIONE_A,
            // SEGMENTO_DEFORMAZIONE_B : Modulo.SEGMENTO_DEFORMAZIONE_B,

            Result.push(OggettoModulo)
          }
          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
        this.PopupTensioneAssorbimento = !this.PopupTensioneAssorbimento
      },

      OnClickApriPopup()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Lunghezza    = (this.Catena.Moduli[i].LUNGHEZZA_SPEZZONE / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false

            //Dati moduli presenti nella catena
            // CATENA                  : Modulo.CATENA,
            // MODULO                  : Modulo.MODULO,
            // INCLINOMETRO            : Modulo.INCLINOMETRO,
            // ESTENSIMETRO            : Modulo.ESTENSIMETRO,
            // PIEZOMETRO              : Modulo.PIEZOMETRO,
            // TERMOMETRO              : Modulo.TERMOMETRO,
            // ACCELEROMETRO           : Modulo.ACCELEROMETRO,
            // MAGNETOMETRO            : Modulo.MAGNETOMETRO,
            // PROFONDITA_TESTA        : Modulo.PROFONDITA_TESTA,
            // PROFONDITA_CODA         : Modulo.PROFONDITA_CODA,
            // LUNGHEZZA_SPEZZONE      : Modulo.LUNGHEZZA_SPEZZONE,
            // ORIENTAMENTO            : Modulo.ORIENTAMENTO,
            // SEGMENTO_DEFORMAZIONE_A : Modulo.SEGMENTO_DEFORMAZIONE_A,
            // SEGMENTO_DEFORMAZIONE_B : Modulo.SEGMENTO_DEFORMAZIONE_B,

            Result.push(OggettoModulo)
          }
          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
        this.PopupStorici = !this.PopupStorici
      },
      OnClickApriPopupStazioneMeteo()
      {
        let Result = []
        if(this.Catena.Moduli.length != 0)
        {
          for(let i = 0; i < this.Catena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.Catena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false

            //Dati moduli presenti nella catena
            // CATENA                  : Modulo.CATENA,
            // MODULO                  : Modulo.MODULO,
            // INCLINOMETRO            : Modulo.INCLINOMETRO,
            // ESTENSIMETRO            : Modulo.ESTENSIMETRO,
            // PIEZOMETRO              : Modulo.PIEZOMETRO,
            // TERMOMETRO              : Modulo.TERMOMETRO,
            // ACCELEROMETRO           : Modulo.ACCELEROMETRO,
            // MAGNETOMETRO            : Modulo.MAGNETOMETRO,
            // PROFONDITA_TESTA        : Modulo.PROFONDITA_TESTA,
            // PROFONDITA_CODA         : Modulo.PROFONDITA_CODA,
            // LUNGHEZZA_SPEZZONE      : Modulo.LUNGHEZZA_SPEZZONE,
            // ORIENTAMENTO            : Modulo.ORIENTAMENTO,
            // SEGMENTO_DEFORMAZIONE_A : Modulo.SEGMENTO_DEFORMAZIONE_A,
            // SEGMENTO_DEFORMAZIONE_B : Modulo.SEGMENTO_DEFORMAZIONE_B,

            Result.push(OggettoModulo)
          }
          this.VettoreModuli = []
          this.VettoreModuli = Result
        }
        this.PopupStazioneMeteo = !this.PopupStazioneMeteo
      },

      OnChangeDataAllineamento()
      {
        this.ObjAllineamento.ListaOre = [];
      },

      OnChangeNuovaDataAbbinato()
      {
        this.ObjAbbinati.ListaOre = [];
      }
    },
    computed:
    {
      EsportaXLSX:
      {
        get()
        {
          return this.MenuTrigger.StampaXLSX 
        }
      },
      CurrentObjPresenzaMenu :
      {
        get()
        {
          return this.ObjPresenzaMenu
        }
      },
      ApriPopupStorici:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupStorici 
        }
      },
      ApriPopupTensioneAssorbimento:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupTensioneAssorbimento 
        }
      },
      ApriPopupStazioneMeteo:
      {
        get()
        {
          return this.MenuTrigger.ApriPopupStazioneMeteo 
        }
      },
    },
    watch:
    {
      EsportaXLSX:
      {
        handler()
        {
          this.EsportaExcel()
        },
        deep : true
      },
      ApriPopupStorici:
      {
        handler()
        {
          this.OnClickApriPopup()
        },
        deep : true
      },
      ApriPopupTensioneAssorbimento:
      {
        handler()
        {
          this.OnClickApriPopupTensioneAssorbimento()
        },
        deep : true
      },
      ApriPopupStazioneMeteo:
      {
        handler()
        {
          this.OnClickApriPopupStazioneMeteo()
        },
        deep : true
      },
    },

    beforeMount()
    {
      this.CurrentObjPresenzaMenu.VisualizzaStazioneMeteo = false
      this.ListaOreStandard = []
      for (let i = 0; i < 24; i++)
      {
        let Ora = i
        if (i < 10)
          Ora = '0' + Ora
        this.ListaOreStandard.push(Ora + ':00')
      }
      this.Catena.MouseInfo = {}
      this.Catena.MouseInfo.Coordinates = {x : 0, y : 0}
      this.Catena.MouseInfo.Detail = {}
      this.Catena.MouseOverOnCoords = {x: 0, y : 0}
      this.Catena.TipiAllarmiAttivi = []
      let ParametriURL = TZGenericFunct.GetURLParameters()    
      if (ParametriURL.ChiaveCatena != undefined && ParametriURL.ChiaveSito != undefined)
      {
        this.CaricamentoDatiCatena = true
        
        this.ChiaveCatena = ParametriURL.ChiaveCatena
        this.ChiaveSito = ParametriURL.ChiaveSito
        this.Catena.EstensimetroPresente = ParametriURL.Estensimetri == 'true'
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId
        this.CaricaDatiCatena()
      }
      this.ResizeGraphs()
      window.addEventListener('resize', this.ResizeGraphs)
    },

    beforeUnmount()
    {
      clearInterval(this.IntervalIDRefreshDati)
      if (!this.PopupStorici && !this.PopupTensioneAssorbimento && !this.PopupStazioneMeteo)
      {
        this.VettoreModuli = []
        for(let i = 0; i < this.Catena.Moduli.length; i++)
        {
          let OggettoModulo          = {}
          OggettoModulo.Id           = this.Catena.Moduli[i].MODULO
          OggettoModulo.Catena       = this.Catena.Moduli[i].CATENA
          OggettoModulo.Profondita   = (this.Catena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
          this.VettoreModuli.push(OggettoModulo)
        }

        let URLSalvato = SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena
        
        SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(this.Catena.DatiCatena.CHIAVE_SITO, 
                                                                              this.Catena.DatiCatena.CHIAVE,
                                                                              this.Catena.Descrizione,
                                                                              SystemInformation.TipoPopupAperto,
                                                                              this.VettoreModuli,
                                                                              TZDateFunct.ChangeDate(new Date(), 'day', -7), 
                                                                              new Date(), 
                                                                              '00:00', 
                                                                              TZDateFunct.FormatDateTime('hh:nn', new Date),
                                                                              false,
                                                                              false,
                                                                              false,
                                                                              false)

        SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena  = URLSalvato
        localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
        localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici))
      }
      window.removeEventListener('resize', this.ResizeGraphs)
    },
    
    mounted()
    {
      if(SystemInformation.UserInformation.AutorefreshDati != 0)
      {
        this.IntervalIDRefreshDati = setInterval(() => {
                                                      if(this.FlagAbilitaRefreshDati)
                                                        this.CaricaDatiCatena()
                                                    },SystemInformation.UserInformation.AutorefreshDati*60000)
      }
    },
}
</script>
